import React from 'react'
import { connect } from 'react-redux'
import { Route, withRouter, Redirect } from 'react-router-dom'
import { authActions } from '../actions'
import Redirecting from '../components/Redirecting'
import { NotPermission } from '../containers'
import { getPermittedFunctionalities } from '../utils/permissions'
import { authType } from '../utils/auth'

const functionalities = [
  {
    functionality: 'product-map-status',
    url: '/mapa-de-produtos/mapa-de-quimicos'
  },
  {
    functionality: 'product-map',
    url: '/mapa-de-produtos/mapa-de-quimicos'
  },
  {
    functionality: 'certificate-control',
    url: '/mapa-de-produtos/mapa-de-quimicos'
  },
  {
    functionality: 'incompatibility-analysis-edit',
    url: '/analise-de-incompatibilidade'
  },
  {
    functionality: 'incompatibility-analysis',
    url: '/analise-de-incompatibilidade'
  },
  {
    functionality: 'licenses',
    url: '/produtos-controlados/licencas'
  },
  {
    functionality: 'consumption-map',
    url: '/produtos-controlados/mapas-de-consumo'
  },
  {
    functionality: 'controlled-products-map',
    url: '/produtos-controlados/relacao-de-produtos-controlados'
  },
  {
    functionality: 'third-parties',
    url: '/licencas-terceiros'
  },
  {
    functionality: 'product-overview',
    url: '/panorama-geral-de-produtos'
  },
  {
    functionality: 'inventory-stock',
    url: '/estoque-produtos-quimicos/estoque'
  },
  {
    functionality: 'inventory-historic',
    url: '/estoque-produtos-quimicos/historico'
  },
  {
    functionality: 'inventory-report',
    url: '/estoque-produtos-quimicos/relatorio'
  },
  {
    functionality: 'management-fispq',
    url: '/controle-de-fispq'
  }
]

const canAccessRoute = (permissions = [], url) => {
  const exists = !!functionalities.find(item => {
    return item.url === url
  })

  if (exists) {
    return !!permissions.find(item => {
      return (item || {}).url === url
    })
  } else {
    return true
  }
}

export const PrivateRoute = ({
  component: Component,
  accessToken,
  permissions,
  signIn,
  location,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
        const permittedFunctionalities = getPermittedFunctionalities(functionalities, permissions)

        if (accessToken) {
          const canAccess = canAccessRoute(permittedFunctionalities, props.location.pathname)

          if (canAccess) {
            return <Component {...props} />
          } else {
            return <NotPermission router={{ location }} {...props} />
          }
        } else {
          if (authType('adfs')) {
            signIn()
            return <Redirecting />
          } else {
            return <Redirect to="/entrar" />
          }
        }
      }}
    />
  )
}

const mapStateToProps = state => ({
  accessToken: state.headers.accessToken,
  permissions: state.auth.permissions
})

const mapDispatchToProps = dispatch => {
  return {
    signIn: () => {
      dispatch(authActions.signIn())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PrivateRoute))



// WEBPACK FOOTER //
// ./src/routes/PrivateRoute.js